import React,  {useState, useEffect, Fragment}       from 'react';
import { Link }     from 'react-router-dom';
import { useTable, useSortBy, usePagination } from 'react-table'
import { Table, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import UpdateIncidentModal from './../IncidentModals/UpdateIncidentModal';
import moment from 'moment-timezone';
import {
  joinArrayToString,
  sortOpi,
  sortDate,
  prettyFormatISOString
} from '../../../utils/formatFunctions'
const styles = {
  'headers': {
    'textAlign'  :  'left',
    'lineHeight' :  '2rem',
  },
  'img': {
    'height' :  'auto',
    'width'  :  '24px',
  },
  'table': {
    'height' :  '75vh',
    'border' :  'none',
  },
  'tableContainer': {
    'fontSize'        :  '.94rem',
    'boxSizing'       :  'border-box',
    'borderRadius'    :  '4px',
    'backgroundColor' :  'rgb(250, 250, 250)',
    'boxShadow'       :  'rgba(0, 0, 0, 0.2) 0px 0px 10px -2px',
  },
  'tablePadding': {
    'borderLeft'   : '1px solid #ddd',
    'borderRight'  : '1px solid #ddd',
    'borderBottom' : '1px solid #ddd',
  },
  'unset' : {
    'whiteSpace': 'unset'
  },
  'prewrap' : {
    'whiteSpace': 'pre-wrap'
  },
};
const PAGE_SIZE = 10;



function RenderTable({ columns, values }) {
  const { t } = useTranslation(["translation"]);

  function slaRowStriping(nextSendEpoch) {
    if (nextSendEpoch === null) {
      return 'white'
    }
    const now = moment.utc()
    const slaDate = moment(nextSendEpoch * 1000)
    const timeDelta = slaDate.diff(now, 'minutes')

    if (timeDelta <= 0) {
      // pastel red
      return '#FF746C'
    } else if (timeDelta > 0 && timeDelta <= 60 ) {
      // pastel orange
      return '#FFA86C'
    } else if (timeDelta > 60 && timeDelta <= 180) {
      // pastel yellow
      return '#FFEE8C'
    } else {
      return 'white'
    }
  };

  const data = React.useMemo(() => 
  values
  , [values]);

  const sorting = React.useMemo(
    () => [
      {
        id: "nextSendDate",
        desc: false
      }
    ],
    []
  );
  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? 'desc' : 'asc') : '';
  };

  const widthDict = {
    'jira_id': 122,
    'affectedService': 260,
    'data_center': 300,
    'start_date': 230,
    'next_send_date': 230,
    'update_next_send_date': 230
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: sorting,
        pageIndex: 0,
        pageSize: 10
      }
    },
    useSortBy,
    usePagination,
  )
  return (
    <Fragment>
      <Table bordered {...getTableProps()} className="cy-history-table">  
        <thead>
          {headerGroups.map(headerGroup => (
            <tr className='rt-thead' {...headerGroup.getHeaderGroupProps()} >
              {headerGroup.headers.map((column, i) => {
                const {render, getHeaderProps} = column
                return (
                  <th style={{ width: column.size || widthDict[column.id] }} className={generateSortingIndicator(column) + " " + column.id + "-header"} key={'header' + i} {...getHeaderProps(column.getSortByToggleProps())}>{render("Header")}</th>
                )
              })}
            </tr>
          ))}
        </thead>
        {page.length > 0 && <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            let styling = {backgroundColor: slaRowStriping(row.original.nextSendEpoch)};
            prepareRow(row);
            return (
              <Fragment key={row.getRowProps().key}>
                <tr style={styling}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    );
                  })}
                </tr>
              </Fragment>
            );
          })}
        </tbody>}
        {page.length == 0 &&  <><tr><td/><td/><td/><td/><td/><td/></tr>
        <div style={styles.noData} className='rt-noData'>{t('containers.incidentManagmentSLADetailsTable.noData')}</div>
        <tr><td/><td/><td/><td/><td/><td/></tr>
        <tr><td/><td/><td/><td/><td/><td/></tr>
        <tr><td/><td/><td/><td/><td/><td/></tr>
        <tr><td/><td/><td/><td/><td/><td/></tr>
        <tr><td/><td/><td/><td/><td/><td/></tr>
        <tr><td/><td/><td/><td/><td/><td/></tr></>}
      </Table>
      <div style={{display: 'flex', textAlign: 'center', paddingBottom: '1rem'}}>
        <Col md={5} >
          <Button
            variant="secondary"
            onClick={() => gotoPage(0)}
            style={{width: '15vw', marginRight: '5px'}}
            disabled={!canPreviousPage}
          >
            {"First"}
          </Button>
          <Button
            variant="secondary"
            onClick={previousPage}
            style={{width: '15vw'}}
            disabled={!canPreviousPage}
          >
            {"Prev"}
          </Button>
        </Col>
        <Col md={2} style={{ marginTop: 7 }}>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>
        </Col>
        <Col md={5}>
          <Button variant="secondary" style={{width: '15vw', marginRight: '5px'}} onClick={nextPage} disabled={!canNextPage}>
            {"Next"}
          </Button>
          <Button
            variant="secondary"
            style={{width: '15vw'}}
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {"Last"}
          </Button>
        </Col>
      </div>
    </Fragment>
  );
}



const SlaTable = ({slaIncidents, requestSlaIncidents, listSize}) => {
  const [page, setPage] = useState('');
  const [sortCol, setSortCol] = useState('start_date');
  const [sortDirection, setSortDirection] = useState('DESC');
  const [totalIncidents, setTotalIncidents] = useState(listSize);
  useEffect(() => {
    setRowData(slaIncidents);
  }, [slaIncidents])

  const { headers, tableContainer } = styles;
  const [rowData, setRowData] = useState(slaIncidents);
  if (document.getElementsByClassName("-center")[0]){
    document.getElementsByClassName("-center")[0].style.display = 'none'
  }
  useEffect(() => {
    //Pages populated with data until page 10, on page 8, more data is pulled.
    if (totalIncidents - (PAGE_SIZE * page) == 40){
      requestSlaIncidents(100, totalIncidents, sortCol, sortDirection);
      setTotalIncidents(totalIncidents + 100);
    }
  }, [page])

  function nextSendEpochSort(rowA, rowB, id, desc) {
    if (!rowA.original.nextSendEpoch) return 1;
    if (!rowB.original.nextSendEpoch) return -1;
    if (rowA.original.nextSendEpoch > rowB.original.nextSendEpoch) return 1;
    if (rowB.original.nextSendEpoch > rowA.original.nextSendEpoch) return -1;
    return 0;
  }


  const columns = React.useMemo(
    () => [
        {
          Header: <b style={styles.test} data-cy='id-header'>Incident Id</b>,
          headerStyle: headers,
          id: 'jiraId',
          size: '122px',
          Cell          : ({value}) => (<Link style={{width: '122px'}} to={`/edit/${value}`} >{value}</Link>),
          accessor      : "jiraId",
          sortMethod    : (a, b) => sortOpi(a, b),
        },
        {
          Header: <b style={styles.test} data-cy='priority-type-header'>Priority</b>,
          headerStyle: headers,
          id: 'priorityType',
          size: '30px',
          accessor      : "priorityType",
          Cell          : ({value}) => (<div style={{width: '30px'}}>{value}</div>),
          sortMethod    : (a, b) => sortOpi(a, b),
        },
        {
          Header      : <b data-cy="internal-header">Audience</b>,
          headerStyle : headers,
          id          : 'isInternal',
          size       : '75px',
          accessor    : data => <div style={{width: '75px'}}>{data.isInternal == 'Y' ? 'Internal' : 'External'}</div>,
        },
        {
          Header: <b data-cy='service-header'>Service(s)</b>,
          headerStyle: headers,
          id: 'affectedServices',
          accessor: 'affectedServices',
          size: '260px',
          Cell:  (value) => (<div style={{width: '260px'}}>{joinArrayToString(value.row.original.affectedServices)}</div>),
        },
        {
          Header: <b data-cy="data-center-header">Data Center(s)</b>,
          headerStyle: headers,
          id: 'affectedDataCenters',
          accessor: 'affectedDataCenters',
          size: '150',
          Cell    : (value) => (<div style={{width: '150'}}>{joinArrayToString(value.row.original.affectedDataCenters)}</div>),
        },

        {
          Header: <b data-cy="start-date-header">Start Date</b> ,
          headerStyle: headers,
          id: 'startDate',
          accessor: 'startDate',
          size: '200px',
          Cell      : ({value}) => (<div style={{width: '200px'}}>{prettyFormatISOString(value)}</div>),
          sortMethod    :  (a, b) => sortDate(a, b),
        },
        {
          Header: <b data-cy='set-next-send-date-header'>SLA Send Date</b> ,
          headerStyle: headers,
          id: 'nextSendDate',
          size: '350px',
          accessor: data => <div style={{width: '350px'} }>{data.nextSendDate === null ? 'Ongoing Incident' : prettyFormatISOString(moment(data.nextSendEpoch * 1000).toISOString())} <UpdateIncidentModal incidentDetails={{jira_id : data.jiraId, next_send_date: data.nextSendEpoch*1000, priority_type: data.priorityType}} /></div>,
          sortType    :  nextSendEpochSort
          // <AuthorizationWrapper requiredAction={requiredUpdateIncidentAction}><UpdateIncidentModal jiraId={data.jiraId} nextSendDate={data.next_send_date}/></AuthorizationWrapper>,
        },
      ]
    )

  return (
    <div style={tableContainer}>
      <RenderTable columns={columns} values={rowData} />
    </div>
  );
}

export default SlaTable;
